import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SolutionEcoPro } from 'src/app/core/_models/solutionEcoPro';

@Component({
  selector: 'app-dialog-solution-eco-pro',
  templateUrl: './dialog-solution-eco-pro.component.html',
  styleUrls: ['./dialog-solution-eco-pro.component.scss']
})
export class DialogSolutionEcoProComponent implements OnInit {
  form: any;
  currentItem: SolutionEcoPro = { structureTypesProject: [] };

  constructor(
    public dialogRef: MatDialogRef<DialogSolutionEcoProComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.form = this.formBuilder?.group({
      solutionEcoProId: [null],
      rank: [''],
      displayName: ['', Validators.required]
    });

    if (this.data?.solutionEcoPro) {
      this.currentItem = this.data.solutionEcoPro;
      this.form.reset();
      this.form.patchValue(this.currentItem);
    }
  }

  get formCrls() {
    return this.form?.controls;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
